<script>
export default {
  props: ["isVisible", "message"],
  name: "ErrorMessage"
}
</script>

<template>
<div v-if="isVisible" class="has-error">
  <small><strong>{{message}}</strong></small>
</div>
</template>

<style scoped>
</style>